export const getCleanIdFromObjectId = (hitId: string) => hitId?.split('~')[1];
